import React from 'react';
import styles from './style.module.css';
import { AppDownloadButtons } from 'components';
import { DashboardPageContent } from 'services/content';

const BasicDashboard = () => {
  const { basicUserDashboard } = DashboardPageContent;

  return (
    <>
      <div className="coop-l-container" data-testid="basic-dashboard">
        <div className={`${styles.dashboard} coop-l-medium-8 coop-l-large-8`}>
          <div className={`box-container drop-shadow ${styles.list_container}`}>
            <h1>{basicUserDashboard.heading1}</h1>
            <p>{basicUserDashboard.subText1}</p>
            <br />
            <h2>{basicUserDashboard.subHeading1}</h2>
            <AppDownloadButtons />
            <p className={styles.separator}>or</p>
            <h2>{basicUserDashboard.subHeading2}</h2>
            <a
              className={`${styles.buttonText} coop-btn coop-btn--primary`}
              href="https://heypharmacist.co.uk/services">
              {basicUserDashboard.buttonText}
            </a>
            <h1>{basicUserDashboard.heading2}</h1>
            <p>{basicUserDashboard.subText2}</p>
            <h2>{basicUserDashboard.subHeading3}</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicDashboard;
